<template>
  <v-app id="app">
    <v-main>
      <SplashScreen v-if="loading" />

      <router-view v-else />
    </v-main>

    <AlertBar ref="alertBar" />
  </v-app>
</template>

<script>
import { mapActions } from "vuex";
import { loadSession, signOut } from "@/services/auth";
import { getWallet } from "@/services/wallet";
import SplashScreen from "@/components/splashScreen/SplashScreen";
import AlertBar from "@/components/alertBar/AlertBar";

export default {
  name: "App",

  components: {
    SplashScreen,
    AlertBar,
  },

  data() {
    return {
      loading: true,
    };
  },

  created() {
    this.handleSession();
  },

  beforeMount() {
    this.$root.$on("alert", this.handleAlert);
    this.$root.$on("sign-out", this.signOut);
    this.$root.$on("load-session", this.handleSession);
  },

  beforeDestroy() {
    this.$root.$off("alert", this.handleAlert);
    this.$root.$off("sign-out", this.signOut);
    this.$root.$off("load-session", this.handleSession);
  },

  methods: {
    ...mapActions(["setUser", "setWallet", "setSignOut"]),

    async handleSession(callback) {
      const token = this.$store.getters.accessToken;

      if (token) {
        try {
          const { data } = await loadSession();

          this.setUser(data);

          await this.getWallet();
        } catch {
          this.signOut();
          callback?.(false);
        }
      }

      this.loading = false;
    },

    async getWallet() {
      const { data } = await getWallet();

      this.setWallet(data);
    },

    async signOut() {
      try {
        this.loading = true;

        await signOut();
        await this.setSignOut();

        if (this.$route.name !== "SignIn")
          this.$router.push({ name: "SignIn" });
      } catch (error) {
        this.$alert(error?.message, "error");
      } finally {
        setTimeout(() => {
          this.loading = false;
        }, 1000);
      }
    },

    handleAlert(event) {
      this.$refs.alertBar.handleAlert(event);
    },
  },
};
</script>

<style lang="scss">
html {
  background: $neutral;
}

#app {
  background: $neutral;
}
</style>
